export enum ASSET_TYPE_ENUM {
	Player = 'player',	// player icon asset
	Social = 'social',	// social icon asset (Twitch, Twitter, etc)
	Static = 'static',	// normal static image asset, for placement anywhere
	Markup = 'markup'		// HTML
}
